import React, { useEffect, useState } from "react";
import Card from "components/Card";
import Page from "components/Page";
import Text from "components/Text";
import constants from "../../../constants";
import { withTranslation } from "react-i18next";
import styles from "./FiscalYear.module.scss";
import useFiscalYearModule from "./useFiscalYearModule";
import Loader from "components/Loader";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useOfficeById } from "repositories/office-repository";
import { decodeId } from "utils";

const FiscalYear = ({ history, t, location }) => {
  const [selectFiscalYear, setSelectFiscalYear] =
    useState("January - December");
  const {
    data: { isAnyLoading, data, error },
    methods: { setStartMonth, setEndMonth, handleSubmit },
  } = useFiscalYearModule(t);

  let { officeId } = useParams();
  const decodeOfficeId = parseInt(decodeId(officeId));
  const { data: officeData } = useOfficeById(decodeOfficeId);
  const goBack = () => {
    history.push({
      pathname: constants.routes.accountOwner.timelinePreferences.replace(
        ":officeId",
        officeId
      ),
      state: { officeName: location?.state?.officeName },
    });
  };

  const formattedFiscalYears = constants.fiscalYearOptions.map((option) => {
    const [startMonthStr, endMonthStr] = option.split(" - ");

    return {
      label: option,
      startMonth: constants.monthToNumber[startMonthStr.trim()],
      endMonth: constants.monthToNumber[endMonthStr.trim()],
    };
  });

  const getMonthNumbers = (fiscalYearString) => {
    const [startMonth, endMonth] = fiscalYearString.split(" - ");
    return {
      start: constants.monthToNumber[startMonth.trim()],
      end: constants.monthToNumber[endMonth.trim()],
    };
  };

  const findLabelFromDates = (startMonth, endMonth) => {
    return constants.fiscalYearOptions.find((label) => {
      const { start, end } = getMonthNumbers(label);
      return start === startMonth && end === endMonth;
    });
  };

  useEffect(() => {
    if (data?.data?.startMonth && data?.data?.endMonth) {
      const label = findLabelFromDates(
        data?.data?.startMonth,
        data?.data?.endMonth
      );
      setStartMonth(data?.data?.startMonth);
      setEndMonth(data?.data?.endMonth);
      setSelectFiscalYear(label);
    }
  }, [data]);

  return (
    <>
      {isAnyLoading && <Loader />}
      <Page title={t("accountPreferences.fiscalYearDuration")} onBack={goBack}>
        <p className="pms_subtitle">
          {location?.state?.officeName || officeData?.name}
        </p>

        <Card className={styles.fiscal_year_card}>
          <Text size="16px" weight="600" color="#587E85" marginBottom="24px">
            {t("dashBoard.SelectFiscalYear")}
          </Text>
          <div className={styles.radio_btn_parent + " " + "ch-radio"}>
            {formattedFiscalYears.map((item, index) => (
              <label key={index} className={styles.radio_label}>
                <input
                  type="radio"
                  name="fiscalYearSelection"
                  value={item.label}
                  checked={selectFiscalYear === item.label}
                  onChange={() => {
                    setSelectFiscalYear(item.label);
                    setStartMonth(item.startMonth);
                    setEndMonth(item.endMonth);
                  }}
                />
                <span>{item?.label}</span>
              </label>
            ))}
          </div>
          {error && <span className="error-msg mt-4">{error}</span>}
          <div className="add-event-btn-box mt-4">
            <button
              className="button button-round button-shadow mr-4 mt-2"
              title={t("accountOwner.addEvent")}
              onClick={handleSubmit}
            >
              {t("save")}
            </button>
            <button
              className="button button-round button-dark button-border mt-2"
              title={t("cancel")}
              onClick={goBack}
            >
              {t("cancel")}
            </button>
          </div>
        </Card>
      </Page>
    </>
  );
};
export default withTranslation()(FiscalYear);
